// Admin service — thin axios wrapper over /api/admin/*
// Every call uses the same session cookie as the rest of the app; the
// backend enforces admin permissions per-request.
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin`;

axios.defaults.withCredentials = true;

export async function adminWhoami() {
  const res = await axios.get(`${API}/whoami`);
  return res.data;
}

export async function adminStats() {
  const res = await axios.get(`${API}/stats`);
  return res.data;
}

export async function adminSearchPlayers(q = "", limit = 40) {
  const res = await axios.get(`${API}/players`, { params: { q, limit } });
  return res.data;
}

export async function adminGetPlayer(userId) {
  const res = await axios.get(`${API}/players/${userId}`);
  return res.data;
}

export async function adminGrantVip(userId, days) {
  const res = await axios.post(`${API}/players/${userId}/grant-vip`, { days });
  return res.data;
}

export async function adminRemoveVip(userId) {
  const res = await axios.post(`${API}/players/${userId}/remove-vip`);
  return res.data;
}

export async function adminGrantFounder(userId) {
  const res = await axios.post(`${API}/players/${userId}/grant-founder`);
  return res.data;
}

export async function adminRemoveFounder(userId) {
  const res = await axios.post(`${API}/players/${userId}/remove-founder`);
  return res.data;
}

export async function adminGrantCurrency(userId, kind, amount) {
  const res = await axios.post(`${API}/players/${userId}/grant-currency`, {
    kind, amount,
  });
  return res.data;
}

export async function adminResetCrate(userId) {
  const res = await axios.post(`${API}/players/${userId}/reset-crate`);
  return res.data;
}

export async function adminUnlockWorlds(userId) {
  const res = await axios.post(`${API}/players/${userId}/unlock-worlds`);
  return res.data;
}

export async function adminResetProgress(userId) {
  const res = await axios.post(`${API}/players/${userId}/reset-progress`, {
    confirm: "RESET",
  });
  return res.data;
}

export async function adminResetCosmetics(userId) {
  const res = await axios.post(`${API}/players/${userId}/reset-cosmetics`, {
    confirm: "RESET",
  });
  return res.data;
}

export async function adminResetAchievements(userId) {
  const res = await axios.post(`${API}/players/${userId}/reset-achievements`, {
    confirm: "RESET",
  });
  return res.data;
}

export async function adminPurchases({ plan, status, q, limit = 100 } = {}) {
  const res = await axios.get(`${API}/purchases`, {
    params: { plan, status, q, limit },
  });
  return res.data;
}

export async function adminActivity(limit = 30) {
  const res = await axios.get(`${API}/activity`, { params: { limit } });
  return res.data;
}

export async function adminLeaderboard(q = "", limit = 100) {
  const res = await axios.get(`${API}/leaderboard`, { params: { q, limit } });
  return res.data;
}

export async function adminLeaderboardDelete(entryId) {
  const res = await axios.delete(`${API}/leaderboard/${entryId}`);
  return res.data;
}

export async function adminSystem() {
  const res = await axios.get(`${API}/system`);
  return res.data;
}

export async function adminAudit(limit = 100) {
  const res = await axios.get(`${API}/audit`, { params: { limit } });
  return res.data;
}
